export const validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const validatePasswordLength = (password) => {
  return password.length > 6;   
}
export const validatePasswordSpecialCharacters = (password)=>{
  return (/[!@#$%^&*()+=._-]/.test(password));
}
export const validatePasswordNumber = (password) => {
  return /[0-9]/.test(password);
}
export const validatePasswordAlphabet = (password) => {
  return new RegExp(/[a-z]/).test(password) || new RegExp(/[A-Z]/).test(password);
}
export const validateRequired = (value) => {
  return value && value.length > 0;
}
export const validatePhone = (value) => {
   return /^\(?([0-9]{3})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/.test(value)
}


// WEBPACK FOOTER //
// ./src/utils/validations.js